'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconGaugeSimple, iconGaugeSimpleTag } from '@ni/nimble-components/dist/esm/icons/gauge-simple';
import { wrap } from '../../utilities/react-wrapper';

export type { IconGaugeSimple };
export { iconGaugeSimpleTag };
export const NimbleIconGaugeSimple = wrap(IconGaugeSimple);